import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import dayjs from 'dayjs';
import { UserProfile } from '@clerk/clerk-react';
import { useNavigate } from 'react-router-dom';


const MyAccount = () => {
    const navigator = useNavigate()
    return (
        <>
            <Helmet>
                <title>Profile | TLK</title>
            </Helmet>
            <div className="min-h-screen gradient-bg-1">
                <div className="fixed w-full top-0 bg-background/95 backdrop-blur-sm border-b border-border px-4 py-3 flex items-center gap-3 z-10">
                    <button className="text-foreground"
                        onClick={() => navigator(-1)}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-arrow-left w-6 h-6"
                        >
                            <path d="m12 19-7-7 7-7" />
                            <path d="M19 12H5" />
                        </svg>
                    </button>
                    <h1 className="text-lg font-semibold text-foreground">My Profile</h1>
                </div>
                <div
                    className=" pt-[100px] max-w-2xl mx-auto"
                    style={{ opacity: 1, transform: "none" }}
                >
                    <UserProfile />
                </div>
            </div>
        </>
    );
}

export default MyAccount;
